export default "__VITE_ASSET__DmXHsnPl__"